// extracted by mini-css-extract-plugin
export default {"Recipients":"styles_Recipients__8jAC3","container":"styles_container__Whkpt","addMoreButton":"styles_addMoreButton__2Zdbq"};